var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showWrap)?_c('div',{staticClass:"wrap",class:_vm.showContent ?'fadein':'fadeout'},[_vm._v(_vm._s(_vm.text))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }